import { type CustomTooltipProps } from "ag-grid-react"

import { SalesAndForecastGraphCard } from "~/components/home/SalesAndForecastGraphCard"
import { leafVariantIds } from "~/components/planning/ProductTable/columns/cellHelpers"
import { Card, CardContent, CardHeader, CardTitle } from "~/components/reusable/Card"

import HeaderTooltip from "./HeaderTooltip"
import { useSkuStore } from "~/providers/sku-store-provider"
import { formatDate, getStartOfCurrentWeekUTC } from "~/utils/datetime"
import { formatName } from "~/utils/namingUtils"
import { addDays } from "date-fns"

const SalesAndForecastTooltip = (
  props: CustomTooltipProps & {
    type: "sales" | "forecast"
    netSalesMode?: "off" | "both" | "only"
  },
) => {
  const selectedWarehouseId = useSkuStore((state) => state.warehouseId)
  const selectedChannel = useSkuStore((state) => state.channel)

  const getHeaderDateRange = () => {
    switch (props.type) {
      case "sales":
        return (
          <div className="text-sm mt-1">
            <p>Last 52 weeks:</p>
            <p>
              {formatDate(addDays(getStartOfCurrentWeekUTC(), -(52 * 7)))} -{" "}
              {formatDate(addDays(getStartOfCurrentWeekUTC(), -1))}
            </p>
          </div>
        )
      case "forecast":
        return (
          <div className="text-sm mt-1">
            <p>Next 52 weeks:</p>
            <p>
              {formatDate(getStartOfCurrentWeekUTC())} -{" "}
              {formatDate(addDays(getStartOfCurrentWeekUTC(), 52 * 7 - 1))}
            </p>
          </div>
        )
    }
  }

  if (props.location === "header") {
    return (
      <HeaderTooltip {...props}>
        <div className="text-sm mt-1">{getHeaderDateRange()}</div>
      </HeaderTooltip>
    )
  }

  // Not props.value: columns differ in what their tooltip callback returns for group rows
  const variantIds = props.node?.group ? (leafVariantIds(props) ?? []) : [props.data.variantId]
  // SKU detail rows have a string `skuId` field; regular variant rows only have `skuIds` (array)
  const skuId =
    !props.node?.group && typeof (props.data as any)?.skuId === "string"
      ? ((props.data as any).skuId as string)
      : undefined

  return (
    <div className="w-fit min-w-170 max-w-[min(1200px,92vw)] mr-6 z-10">
      <Card>
        <CardHeader>
          <CardTitle>{formatName("sale", true, true)} & Demand</CardTitle>
        </CardHeader>
        <CardContent>
          <SalesAndForecastGraphCard
            variantIds={variantIds}
            skuId={skuId}
            warehouseId={selectedWarehouseId}
            channel={selectedChannel}
            netSalesMode={props.netSalesMode}
            graphOnly
            showPreorders
          />
        </CardContent>
      </Card>
    </div>
  )
}

export default SalesAndForecastTooltip
